// packages block
import React, { useReducer } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import AddCircleIcon from "@material-ui/icons/AddCircle";
// common block
import "./style.css";
import { FormButton } from "../../../components/form";
import { SearchInput } from "../../../components/form/searchInput";
// constants, theme, utils and api block
import { BLUE_EIGHT, WHITE } from "../../../theme";

export const TableHeader = ({ handleAdd, searchValue, tableFor }) => {
  const [{ search, searchError }, setData] = useReducer(
    (state, newState) => ({ ...state, ...newState }),
    {
      search: "",
      searchError: false,
    }
  );

  const { role } = useSelector((state) => state.user);
  const { t } = useTranslation();

  const handleChange = (prop) => (event) => {
    searchValue(event.target.value);
    setData({
      [prop]: event.target.value,
      searchError: false,
    });
  };

  return (
    <div className="table-header">
      {tableFor !== "accounts" && <div style={{ width: 400, paddingLeft: 20 }}>
        <SearchInput
          disabled={role === "manager" || role === "readOnly" ? true : false}
          searchIcon={true}
          error={searchError}
          value={search}
          onChange={handleChange}
          label={t("text_search_by_bank_id_or_bank_name")}
          name="search"
          height={35}
        />
      </div>}

      <div style={{ flex: 1, display: "flex", justifyContent: "flex-end" }}>
        <div style={{ paddingLeft: 20 }}>
          <FormButton
            height={40}
            width={"10vw"}
            borderTopRightRadius={15}
            borderTopLeftRadius={15}
            borderBottomLeftRadius={15}
            borderBottomRightRadius={15}
            borderColor={BLUE_EIGHT}
            titleColor={BLUE_EIGHT}
            hoverTitleColor={WHITE}
            hoverBorderColor={BLUE_EIGHT}
            backgroundColor={WHITE}
            hoverBackgroundColor={BLUE_EIGHT}
            title={t("text_add_bank")}
            style={{ textTransform: "none", fontSize: "0.8vw", fontWeight: "700", padding: 0 , textTransform: "capitalize"}}
            onClickHandler={handleAdd}
            startIcon={<AddCircleIcon color="inherit" />}
            disabled={role === "manager" ? false : true}
          />
        </div>
      </div>
    </div>
  );
};
